<template>
  <div>
      <el-select :filterable="true" :value="value" placeholder="应用名称" :size="size" @input="change" :clearable="true">
      <el-option label="----------" value="" />
      <el-option v-for="item in options" :key="item.app_id" :label="item.app_name" :value="item.app_id" />
    </el-select>
  </div>
</template>

<script>

import { fetchAppList } from '@/api/app'
export default {
  data () {
    return {
      options: []
    }
  },
  created () {
    fetchAppList({limit: 0}).then((res) => {
      this.options = res.data.map((item) => { item.id = parseInt(item.id); return item })
    })
  },
  props: ['value', 'size', 'showAllTip', 'showAllTipLabel'],
  methods: {
    change (val) {
      this.$emit('input', val || '')
    },
    handleUpdate () {
      fetchAppList({limit: 0}).then((res) => {
        this.options = res.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/card/components/AppIdSelect.vue